
export class Usuario{
    constructor(
        public nombre: string,
        public email: string,
        public password: string,
        public img?: string,
        public google?: string,
        public role?: string,
        public _id?: string,
    ) { }
}